import React from 'react';
import styled from 'styled-components';

export const AppDetailsTable = styled.div`
  display: table;
  > div {
    display: table-row;
    > div {
      display: table-cell;
      padding: 0 5px;
    }
    > div:nth-of-type(1) {
      color: #c6c6c6;
      text-align: right;
    }
    > div:nth-of-type(2) {
      padding-left: 16px;
    }
  }
`;

const DetailsTable = ({ data }) => (
  <AppDetailsTable>
    {data.map(({ col1, col2 }, index) => (
      <div key={index}>
        <div>
          {col1}
          {col1 ? ':' : ''}
        </div>
        <div>{col2}</div>
      </div>
    ))}
  </AppDetailsTable>
);

export default DetailsTable;
